import { useDispatch, useSelector } from 'react-redux';

import DropDownButtonLegacy from 'common/components/drop-downs/legacy/dropDownButtonLegacy';
import SimpleButtonContainerContent from 'common/components/drop-downs/legacy/simpleDropDownButtonContainerContent';
import { RootState } from 'app/store';
import { FC } from 'react';
import {
  getAvailableAttributionModels,
  getSelectedAttributionModel,
  selectAttributionModel
} from './availableAttributionModelsSlice';

const AttributionButton: FC<{
  dropDirection?: 'left' | 'right';
  width?: string;
}> = ({ dropDirection = 'right', width = 'w-40' }) => {
  const dispatch = useDispatch();

  const { isPocModeActive } = useSelector(
    (state: RootState) => state.pocToggle
  );

  const attributeModelRoutes = useSelector((state: RootState) =>
    getAvailableAttributionModels(state, isPocModeActive)
  );

  const selectedAttributionModel = useSelector((state: RootState) =>
    getSelectedAttributionModel(state, isPocModeActive)
  );

  const getSelectedAttributionDropdownLabel = () =>
    attributeModelRoutes.find((route) => route.key === selectedAttributionModel)
      ?.label ?? 'Select an Attribution Model';

  return (
    <>
      <DropDownButtonLegacy
        dropDownItems={attributeModelRoutes}
        selectDropDownItem={(key) => dispatch(selectAttributionModel(key))}
        dropDirection={dropDirection ?? 'right'}
      >
        <SimpleButtonContainerContent
          dropdownLabel={getSelectedAttributionDropdownLabel()}
          additionalContainerStyling={`${width} bg-white rounded border border-neutral-200`}
        />
      </DropDownButtonLegacy>
    </>
  );
};

export default AttributionButton;
